import './index.scss';

import { createRoot } from 'react-dom/client';
import App from 'app/App';

// eslint-disable-next-line import/extensions
import './i18n';

const containter = document.getElementById('root');
const root = createRoot(containter!);
root.render(<App />);
